'use client';

import { Fragment } from "react";
function wrapIfTextCompatible(children, wrapper) {
  if (isTextCompatible(children)) return wrapper(children);
  return children;
}
const allowlist = [
  "b",
  "br",
  "em",
  "i",
  "span",
  "strong",
  "sub",
  "sup"
];
function isTextCompatible(children) {
  if (!children) return true;
  if (typeof children === "boolean") return true;
  if (typeof children === "number") return true;
  if (typeof children === "string") return true;
  if (typeof children === "bigint") return true;
  if (Symbol.iterator in children) {
    for (const child of children) {
      if (!isTextCompatible(child)) return false;
    }
    return true;
  }
  if (children instanceof Promise) return false;
  if (allowlist.includes(children.type)) return true;
  if (isFragment(children)) return isTextCompatible(children.props.children);
  return false;
}
function isFragment(children) {
  if (typeof children !== "object" || children === null) return false;
  if (!("type" in children)) return false;
  return children.type === Fragment;
}
export {
  wrapIfTextCompatible
};
